export default __webpack_public_path__ + "static/datasets-44585295ce98860106101a8bbc3fc345.svg";